import React, { useEffect, useState } from "react";
import { sortObjectsByAlphabet } from "../../utils";
import SelectV2 from "../../view/SelectV2";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as validationService from "../add-device-modal/validationService";

function DeviceTypeField({ deviceTypes, value, onChange, error, disabled }) {

    useEffect(() => {
        validationService.validateDeviceTypeSelected(value, 'deviceType');
        return () => validationService.cleanValidation('deviceType');
    }, [value]);

    const [touched, setTouched] = useState(false);

    const handleChange = (id) => {
        const deviceType = deviceTypes.find((type) => String(type.id) === String(id));
        onChange(deviceType);
        setTouched(true);
    };

    const deviceTypeCopy = sortObjectsByAlphabet(deviceTypes, 'name');
    const deviceTypeOptions = deviceTypeCopy.map((device) => ({
        value: device.id,
        label: device.name
    }));

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="deviceType">Device Type <span className="modal-v2-required-mark">*</span></label>
                <SelectV2
                    inputId="deviceType"
                    className={(error && touched) ? "border-danger" : ""}
                    value={value ?? ""}
                    onChange={handleChange}
                    options={deviceTypeOptions}
                    isDisabled={disabled}
                    placeholder="Select device type"
                    noOptionsMessage={() => "No device types found"}
                />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    debug("DeviceTypeField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.deviceType
    };
}

export default connect(mapStateToProps)(DeviceTypeField);
